import React from 'react';
import './Team.css';

const members = [
  {
    name: 'Deniz Okan',
    role: 'Operations',
    photo: '/images/Deniz Individueel.JPG',
  },
  {
    name: 'Harveer Singh',
    role: 'R&D',
    photo: '/images/Harveer.JPG',
  },
  {
    name: 'Marie de Vet',
    role: 'Product',
    photo: '/images/Marie Individueel.JPG',
  },
];

const Team = () => (
  <section className="team">
    <div className="container">
      <h2 className="team-heading">The Team</h2>
      <div className="team-grid">
        {members.map((member, i) => (
          <div className="team-card" key={i}>
            <div className="team-photo">
              {member.photo
                ? <img src={member.photo} alt={member.name} />
                : <div className="team-photo-placeholder" />}
            </div>
            <div className="team-info">
              <div className="team-name">{member.name}</div>
              <div className="team-role">{member.role}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Team;
